import { BrandLogo, GradientText } from "@/components/ui/gradient";

/**
 * Full-page splash loading. Dùng cho App initial auth check + page lazy
 * load. Replace plain "Đang tải..." text.
 */
export function LoadingPage({
  label = "Đang tải...",
}: {
  label?: string;
}): JSX.Element {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-mesh gap-4">
      <BrandLogo size={80} />
      <GradientText className="text-lg font-semibold">{label}</GradientText>
    </div>
  );
}
